import { AxiosError } from 'axios';
import useSWRImmutable from 'swr/immutable';

import { ProductTypeT, WithStatusT } from '@consumer-frontend/nc-utils';

import { apiEndpoints, FIVE_MINUTES_IN_MS } from '../lib';

export type AccountInfoResponseT = {
  account_id: string;
  debit_card_lock_active: boolean;
  first_name: string;
  last_name: string;
  login: string; // Customer email address
  open_loan_type: ProductTypeT;
  show_fee_saver_status: boolean;
  open_loan_number?: string;
};

export const useAccountInfo = (accountId: string) => {
  const {
    data,
    error,
    isLoading,
  } = useSWRImmutable<WithStatusT<AccountInfoResponseT>, AxiosError>(
    // NOTE: do not use the conditional fetch pattern here as part of the auth
    // flow depends on this request failing when unauthenticated.
    apiEndpoints.dashboard.accountSummary(accountId),
    { dedupingInterval: FIVE_MINUTES_IN_MS }, // Don't re-fetch for 5 minutes
  );

  return {
    accountInfo: data
      ? {
        accountId: data.account_id,
        debitCardLockActive: data.debit_card_lock_active || false,
        email: data.login,
        firstName: data.first_name,
        lastName: data.last_name,
        loanNumber: data.open_loan_number,
        loanType: data.open_loan_type,
        showFeeSaverStatus: data.show_fee_saver_status || false,
      }
      : undefined,
    error,
    isLoading,
    status: data?.status || error?.status,
  };
};
